import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { useDropzone } from "react-dropzone";
import "../dropzone/dropzone.css";
import Dropdown from "../../Icon/Dropdown";
import { Box, FormHelperText, Typography } from "@mui/material";
import { FontFamily } from "../theme/fontFamily";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { ThemeColor } from "../theme/color";
import Delete from "../../Icon/Delete";
import { UploadFileService } from "../../Redux/service/FileService";
import Attachment from "../../Icon/Attachment";


const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid black",
  //   marginTop: 10,
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

const AttachmentDropzone=forwardRef((props,ref)=>{
  const [files, setFiles] = useState([]);
  var docsFile = [];

  const onDrop = useCallback(async (acceptedFiles) => {
    const docsFile = [];
  
    // Generate previews
    const updatedFiles = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );
    setFiles(updatedFiles); // Store previewed files
  
    // Upload each file
    for (const file of acceptedFiles) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await UploadFileService(formData);
        if (response.status === 200) {
          const uploadedUrl = response.data.result;
          docsFile.push(uploadedUrl);
          const matchingFile = updatedFiles.find((f) => f.name === file.name);
          if (matchingFile) {
            matchingFile.uploadedUrl = uploadedUrl;
          }
        }
      } catch (err) {
        console.error("uploadPhotoPost : error ", err);
      }
    }
    // Notify parent
    props.handleMydropzoneFile(docsFile, updatedFiles);
  
    // Optionally clear state (if required)
    setFiles([]);
  }, [props.handleMydropzoneFile]);
  

  const { getRootProps, getInputProps } = useDropzone({
    multiple: true,
    onDrop,
  });

  const handleRemove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
  
    setFiles(newFiles);
  
    // Also filter the uploaded file URLs based on remaining previews
    const updatedDocsFile = newFiles.map(file => file.uploadedUrl); // <- attach this in upload loop
  
    // Notify parent with updated docs + previews
    props.handleMydropzoneFile(updatedDocsFile, newFiles);
  };

  const thumbs = files.map((file, index) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img
          src={file.preview}
          style={img}
          // Revoke data uri after image is loaded
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
        />
        <button onClick={() => handleRemove(index)}>Remove</button>
      </div>
    </div>
  ));

  const resetDropzone = () => {
    //console.log("ononojjoj")
    docsFile=[]
    setFiles([])
    // props?.handleMydropzoneFile([], []); // This will clear the files in Dropzone
  };

  useImperativeHandle(ref, () => ({
    resetDropzone,
    handleRemove
  }));

  useEffect(() => {
    //(files, "nonnoon");
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);

  return (
    <section className="my-dropzone-container1">
      <div
        {...getRootProps({ className: "dropzone" })}
        style={{ display: "flex" }}
      >
        <input {...getInputProps()} />
        <div className="mt-2">
          <Attachment />
          <FormHelperText component="div">{props.helperText}</FormHelperText>
          <Box
            className="w-100"
            sx={
              {
                // height: files.length > 0 ? 200 : 10,
                // overflowY: "scroll",
                // overflowX: "auto",
              }
            }
            // style={{ height: "200px", overflowY: "scroll" }}
          >
            <ul>
              {files?.map((file, index) => (
                <li key={index} className="d-flex">
                  {file.name}
                  <div className="px-1">
                    {" "}
                    <button
                      onClick={() => handleRemove(index)}
                      className="py-1 px-2"
                      style={{
                        background: ThemeColor.RED,
                        borderColor: ThemeColor.RED,
                        borderRadius: "50%",
                        boxShadow: "none",
                      }}
                    >
                      <Delete />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </Box>
        </div>
      </div>
      <div></div>

      {/* <aside style={thumbsContainer}>{thumbs}</aside> */}
      {/* <div className="h-100 w-100">
        <ul>
          {files.map((file, index) => (
            <li key={index} className="d-flex align-items-center">
              {file.name} - {file.size} bytes
              <div className="px-2">
                <button
                  onClick={() => handleRemove(index)}
                  className=""
                  style={{
                    background: ThemeColor.RED,
                    borderColor: ThemeColor.RED,
                    borderRadius: "50%",
                    boxShadow: "none",
                  }}
                >
                  <Delete />
                </button>
              </div>
            </li>
          ))}
        </ul>

       
      </div> */}
    </section>
  );
})

export default AttachmentDropzone;
